import { alpha, Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";

const messageBoxStyle = (theme: Theme) => createStyles({
    root: {
        ...theme.genie.font,
        fontSize: theme.typography.body1.fontSize,
        fontWeight: theme.typography.body1.fontWeight,

        flexWrap: "unset",
        flexGrow: 1,
        position: "relative",
        lineHeight: "20px",

        backgroundColor: "white",
        color: "#555555",
        borderRadius: "3px",
        minWidth: "unset",
        maxWidth: "unset",
        boxShadow:
            "0 12px 20px -10px rgba(255, 255, 255, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 255, 255, 0.2)"
    },

    normal: {
        lineHeight: "1rem",
        "& $container": {
            padding: theme.spacing(1),
        },
    },
    medium: {
        minHeight: "5rem",
        "& $container": {
            padding: theme.spacing(2),
        }
    },
    large: {
        minHeight: "8rem",
        "& $large": {
            padding: theme.spacing(3),
        }
    },

    messageContainer: {
        "& span": {
            fontSize: ".875rem"
        },
        "& span:first-child": {
            fontSize: "1rem"
        }
    },
    info: {
        backgroundColor: alpha(theme.genie.palette.info.dark, 0.8),
        color: theme.genie.palette.info.contrastText,
        boxShadow: theme.genie.palette.info.boxShadow
    },
    success: {
        backgroundColor: alpha(theme.genie.palette.success.dark, 0.8),
        color: theme.genie.palette.success.contrastText,
        boxShadow: theme.genie.palette.success.boxShadow
    },
    warning: {
        backgroundColor: alpha(theme.genie.palette.warning.dark, 0.8),
        color: theme.genie.palette.warning.contrastText,
        boxShadow: theme.genie.palette.warning.boxShadow
    },
    notice: {
        backgroundColor: alpha(theme.genie.palette.notice.dark, 0.8),
        color: theme.genie.palette.notice.contrastText,
        boxShadow: theme.genie.palette.notice.boxShadow
    },
    error: {
        backgroundColor: alpha(theme.palette.error.dark, 0.8),
        color: theme.palette.error.contrastText,
        boxShadow: theme.genie.boxShadow.error
    },
    primary: {
        backgroundColor: alpha(theme.palette.primary.dark, 0.8),
        color: theme.palette.primary.contrastText,
        boxShadow: theme.genie.boxShadow.primary
    },
    secondary: {
        backgroundColor: alpha(theme.palette.secondary.dark, 0.8),
        color: theme.palette.secondary.contrastText,
        boxShadow: theme.genie.boxShadow.secondary
    },

    container: {
        display: "flex",
        alignItems: "center",
    },

    action: {
        flexGrow: 1,
        textAlign: "center"
    },


    icon: {
        display: "block",
        left: "15px",
        position: "absolute",
        top: "50%",
        marginTop: "-15px",
        width: "30px",
        height: "30px"
    },

    infoIcon: {
        color: theme.genie.palette.info.main
    },
    successIcon: {
        color: theme.genie.palette.success.light
    },
    warningIcon: {
        color: theme.genie.palette.warning.light
    },
    errorIcon: {
        color: theme.palette.error.light
    },
    primaryIcon: {
        color: theme.palette.primary.light
    },
    iconContainer: {
        paddingLeft: theme.spacing(),
        paddingRight: theme.spacing(),
        display: "block",
    }

});

export default messageBoxStyle;
